// Once UniversalContainer became huge and export a lot of stuff let's use
// a Barrel export to concentrate all export and keep things more organized
import UniversalContainer from './universal-container';

export * from './universal-container-editing-config';
export * from './universal-container-utils';
export default UniversalContainer;
